import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function NotFound() {
  return (
    <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center', px: 2 }}>
      <Typography variant="h3" color="text.primary">
        404 - Page Not Found
      </Typography>
    </Box>
  );
}
